// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import Navbar from "../../navbar/Navbar";
// import LinkToRegistration from "../../property/component/LinkToRegistration";
// import Stepper from "../../Stepper/component/Stepper";
// import { Button } from "@headlessui/react";
// import Photo_dummy from "../../../Images/Photo_dummy.png";
// // import {
// //   checkEsignStatus,
// //   fetchPartyDetailsEsign,
// //   sendEmailLinkToParties,
// // } from "../eSignSlice"; // Import the async thunk

// import { sendEmailLinkToParties } from "../eSignSlice"; // Import the async thunk

// import "@fortawesome/fontawesome-free/css/all.min.css";
// import "../../../CSS/Loader.css";
// import { selectPdEId } from "../../property/propertySlice";
// import axios from "axios";
// import {
//   checkEsignStatus,
//   fetchesignStatus,
//   fetchPartyDetailsEsign,
// } from "../eSignAPI";

// const ESign = () => {
//   const [GeneratePdf, setGeneratePdf] = useState(false);
//   const [partyDetailsData, setPartyDetailsData] = useState("");
//   const [mudraEsighStatus, setMudraEsighStatus] = useState("");
//   const [eregistionEsignDetails, setEregistionEsignDetails] = useState("");
//   const dispatch = useDispatch();

//   //debugger;
//   const { data, statusData, loading, error } = useSelector(
//     (state) => state.eSign
//   );
//   //debugger;

//   const pde = useSelector(selectPdEId);
//   // useEffect(() => {
//   //   //debugger;
//   //   const response = dispatch(fetchPartyDetailsEsign(pde));
//   //   dispatch(checkEsignStatus(pde)); // Dispatch the action to fetch party details
//   //   dispatch(checkEsignStatus(pde));
//   //   // if (response.arg === pde) {
//   //   //   const result = dispatch(checkEsignStatus(pde));
//   //   //   //debugger;
//   //   //   console.log(result);
//   //   // } else {
//   //   //   console.error("No EsignStatus", error);
//   //   // }
//   // }, [dispatch]);

//   const fetchNesseryDetails = async () => {
//     const pdd = await fetchPartyDetailsEsign(pde);
//     const mes = await checkEsignStatus(pde);
//     const eed = await fetchesignStatus(pde);
//     console.log(pdd);
//     console.log(mes);
//     console.log(eed);
//     setPartyDetailsData(pdd);
//     setMudraEsighStatus(mes);
//     setEregistionEsignDetails(eed);
//   };

//   useEffect(() => {
//     //debugger;
//     fetchNesseryDetails();
//     // setPartyDetailsData(fetchPartyDetailsEsign(pde));
//     // setMudraEsighStatus(checkEsignStatus(pde)); // Dispatch the action to fetch party details
//     // setEregistionEsignDetails(fetchesignStatus(pde));
//     // if (response.arg === pde) {
//     //   const result = checkEsignStatus(pde));
//     //   //debugger;
//     //   console.log(result);
//     // } else {
//     //   console.error("No EsignStatus", error);
//     // }

//     console.log(partyDetailsData);
//     console.log(mudraEsighStatus);
//     console.log(eregistionEsignDetails);
//     console.log(
//       partyDetailsData?.firstparty?.map((item) =>
//         eregistionEsignDetails.some((data) => data.pcode === item.pcode)
//       )
//     );
//   }, []);

//   const generatePdf = async (e) => {
//     //debugger;
//     const pdf1 = e.target.value;
//     setGeneratePdf(true);
//     const meetResponse = await axios.get(
//       `https://localhost:44369/CrystalPDF/GeneratePdf?pde_id=${pde}`
//     );
//     // Implement PDF generation logic
//   };

//   const handleSendClick = async () => {
//     // setLoading(true);
//     const payload = {
//       EmpLeaveRec1: {
//         API_type: "srotype29aug",
//         Client: "sroclient29aug",
//         Parameter: `${pde}`,
//         DocName: `${pde}.pdf`,
//         PDE_ID: pde,
//       },
//     };

//     try {
//       // const result = await sendEmailLinkToParties(payload);
//       dispatch(sendEmailLinkToParties(payload));
//       //  console.log("API Response:", result);
//     } catch (error) {
//       console.error("Failed to send email link:", error.message);
//     } finally {
//       // setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <LinkToRegistration />
//       <div className="flex min-h-screen">
//         {loading && (
//           <div className="loader">
//             <i className="fs-1 fas fa-home house-icon"></i>
//             <div className="text">Loading...</div>
//           </div>
//         )}
//         {/* Other sections */}
//         <div className="w-1/5 bg-white flex justify-center">
//           <Stepper />
//         </div>
//         <div className="w-0.5 border-none bg-neutral-400"></div>
//         <div className="w-full justify-start ms-5">
//           <div className="mt-5">
//             <p className="text-md fw-medium mb-3">
//               Click To View Party Details :
//               <Button
//                 onClick={(e) => {
//                   generatePdf(e); // Call your function to generate the PDF
//                   window.open(
//                     `https://localhost:44378//Report/MyReport.aspx?PDE_ID=${pde}`,
//                     "_blank"
//                   ); // Open a URL in a new tab
//                 }}
//                 className="px-10 py-1 ms-2 bg-blue-500 text-white rounded-full text-sm"
//               >
//                 View Pdf
//               </Button>
//             </p>
//           </div>
//           <div className="mt-5">
//             <p className="text-md fw-medium mb-3">
//               Send Email Link To Parties :
//               <Button
//                 className={`px-10 py-1 ms-2 rounded-full text-sm ${
//                   GeneratePdf
//                     ? "bg-blue-500 text-white cursor-pointer" // Enabled styles
//                     : "bg-gray-400 text-gray-200 cursor-not-allowed" // Disabled styles
//                 }`}
//                 onClick={handleSendClick}
//                 disabled={!GeneratePdf}
//               >
//                 Send
//               </Button>{" "}
//             </p>
//           </div>
//           {/* Party details rendering */}
//           {/* First Party Section */}
//           <div className="space-y-4">
//             <p className="text-md font-bold">First Party</p>
//             <div className="grid-flow-row mt-3">
//               {/* <div className="grid grid-cols-3 mt-3">
//                 {partyDetailsData?.firstparty?.map((item, index) => (
//                   <div
//                     key={index}
//                     className={`relative flex items-start p-2 mb-2 max-w-lg ${
//                       item.status === "Pending"
//                         ? "bg-yellow-200 "
//                         : item.status === "Signed"
//                         ? "bg-green-400 "
//                         : item.status === "Declined"
//                         ? "bg-red-500 "
//                         : ""
//                     }`}
//                   >
//                     {item.nameEng === "asd" && (
//                       <span className="absolute top-2 right-2 text-green-600 font-bold">
//                         Signed
//                       </span>
//                     )}
//                     <p className="text-xl font-bold">{item.sNo}.</p>
//                     <img
//                       className="w-32 h-32 object-cover ms-2 mr-6"
//                       src={Photo_dummy}
//                       alt="Profile"
//                     />
//                     <div>
//                       <h2 className="text-xl font-bold">
//                         Name : {item.nameEng}
//                       </h2>
//                       <p className="text-gray-600">
//                         <b>Address : </b>
//                         {item.address}
//                       </p>
//                       <p className="text-gray-600">
//                         <b>D.O.B :</b> {item.dob}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div> */}
//               <div className="grid grid-cols-2 mt-3">
//                 {partyDetailsData?.firstparty?.map((item, index) => (
//                   <div
//                     key={index}
//                     className="relative flex items-start p-2 mb-2"
//                     // className={`relative flex items-start p-2 mb-2 max-w-lg
//                     //  ${
//                     //   item.status === "Pending"
//                     //     ? "bg-yellow-200 "
//                     //     : item.status === "Signed"
//                     //     ? "bg-green-400 "
//                     //     : item.status === "Declined"
//                     //     ? "bg-red-500 "
//                     //     : ""
//                     // }
//                     // `}
//                   >
//                     {/* Status Label */}
//                     <span
//                       className={`absolute top-2 right-2 text-white font-bold px-2 py-1 rounded text-sm ${
//                         item.status === "Pending"
//                           ? "bg-yellow-300"
//                           : item.status === "Signed"
//                           ? "bg-green-300"
//                           : item.status === "Declined"
//                           ? "bg-red-500"
//                           : ""
//                       }`}
//                     >
//                       {item.status}
//                     </span>
//                     <p className="text-sm font-bold">{item.sNo}.</p>
//                     <img
//                       className="w-32 h-32 object-cover ms-2 mr-6"
//                       src={Photo_dummy}
//                       alt="Profile"
//                     />
//                     <div>
//                       <h2 className="text-sm font-bold">
//                         Name : {item.nameEng}
//                       </h2>
//                       <p className="text-gray-600">
//                         <b>Address : </b>
//                         {item.address}
//                       </p>
//                       <p className="text-gray-600">
//                         <b>D.O.B :</b> {item.dob}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//           {/* Second Party Section */}
//           <div className="space-y-4">
//             <p className="text-md font-bold">Second Party</p>
//             <div className="grid-flow-row mt-3">
//               <div className="grid grid-cols-3 mt-3">
//                 {partyDetailsData?.secondparty?.map((item, index) => (
//                   <div
//                     key={index}
//                     className="relative flex items-start p-2 mb-2 max-w-lg"
//                   >
//                     {/* Status Label */}
//                     <span
//                       className={`absolute top-2 right-2 text-white font-bold px-2 py-1 rounded text-sm ${
//                         item.status === "Pending"
//                           ? "bg-yellow-300"
//                           : item.status === "Signed"
//                           ? "bg-green-300"
//                           : item.status === "Declined"
//                           ? "bg-red-500"
//                           : ""
//                       }`}
//                     >
//                       {item.status}
//                     </span>
//                     <p className="text-sm font-bold">{item.sNo}.</p>
//                     <img
//                       className="w-32 h-32 object-cover ms-2 mr-6"
//                       src={Photo_dummy}
//                       alt="Profile"
//                     />
//                     <div>
//                       <h2 className="text-sm font-bold">
//                         Name : {item.nameEng}
//                       </h2>
//                       <p className="text-gray-600">
//                         <b>Address : </b>
//                         {item.address}
//                       </p>
//                       <p className="text-gray-600">
//                         <b>D.O.B :</b> {item.dob}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//           {/* Witness Section */}

//           <div className="space-y-4">
//             <p className="text-md font-bold">Witness</p>
//             <div className="grid-flow-row mt-3">
//               <div className="grid grid-cols-3 mt-3">
//                 {partyDetailsData?.witness?.map((item, index) => (
//                   <div
//                     key={index}
//                     className="relative flex items-start p-2 mb-2 max-w-lg me-3"
//                   >
//                     {/* Status Label */}
//                     <span
//                       className={`absolute top-2 right-2 text-white font-bold px-2 py-1 rounded text-sm ${
//                         item.status === "Pending"
//                           ? "bg-yellow-300"
//                           : item.status === "Signed"
//                           ? "bg-green-300"
//                           : item.status === "Declined"
//                           ? "bg-red-500"
//                           : ""
//                       }`}
//                     >
//                       {item.status}
//                     </span>
//                     <p className="text-sm font-bold">{item.sNo}.</p>
//                     <img
//                       className="w-32 h-32 object-cover ms-2 mr-6"
//                       src={Photo_dummy}
//                       alt="Profile"
//                     />
//                     <div>
//                       <h2 className="text-sm font-bold">
//                         Name : {item.nameEng}
//                       </h2>
//                       <p className="text-gray-600">
//                         <b>Address : </b>
//                         {item.address}
//                       </p>
//                       <p className="text-gray-600">
//                         <b>D.O.B :</b> {item.dob}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ESign;

//K H A L I D START

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "../../property/component/LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";
import { Button } from "@headlessui/react";
import Photo_dummy from "../../../Images/Photo_dummy.png";
import { sendEmailLinkToParties } from "../eSignSlice";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../../../CSS/Loader.css";
import { selectPdEId } from "../../property/propertySlice";
import axios from "axios";
import {
  checkEsignStatus,
  fetchesignStatus,
  fetchPartyDetailsEsign,
} from "../eSignAPI";

const ESign = () => {
  const [GeneratePdf, setGeneratePdf] = useState(false);
  const [partyDetailsData, setPartyDetailsData] = useState("");
  const [mudraEsighStatus, setMudraEsighStatus] = useState("");
  const [eregistionEsignDetails, setEregistionEsignDetails] = useState("");
  const dispatch = useDispatch();

  const { data, statusData, loading, error } = useSelector(
    (state) => state.eSign
  );

  const pde = useSelector(selectPdEId);

  const fetchNesseryDetails = async () => {
    const pdd = await fetchPartyDetailsEsign(pde);
    const mes = await checkEsignStatus(pde);
    const eed = await fetchesignStatus(pde);
    setPartyDetailsData(pdd);
    setMudraEsighStatus(mes);
    setEregistionEsignDetails(eed);
  };

  useEffect(() => {
    fetchNesseryDetails();
  }, []);

  const generatePdf = async (e) => {
    const pdf1 = e.target.value;
    setGeneratePdf(true);
    await axios.get(
      `https://localhost:44369/CrystalPDF/GeneratePdf?pde_id=${pde}`
    );
  };

  const handleSendClick = async () => {
    const payload = {
      EmpLeaveRec1: {
        API_type: "srotype29aug",
        Client: "sroclient29aug",
        Parameter: `${pde}`,
        DocName: `${pde}.pdf`,
        PDE_ID: pde,
      },
    };

    try {
      dispatch(sendEmailLinkToParties(payload));
    } catch (error) {
      console.error("Failed to send email link:", error.message);
    }
  };

  const fetchPdf = async () => {
    //debugger;
    try {
      const response = await axios.get(
        "https://localhost:44369/Home/ViewDownloadSignedDoc?pde_id=UKPDE2024010100230"
      );

      openBase64PdfInNewTab(response.data);
      //debugger;
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const openBase64PdfInNewTab = (base64Pdf) => {
    try {
      // Decode base64 string to binary data
      const binaryString = window.atob(base64Pdf);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create a blob object from the binary data
      const blob = new Blob([bytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      // Open the blob URL in a new tab
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Failed to open PDF:", error);
    }
  };
  return (
    <>
      <Navbar />
      <LinkToRegistration />
      <div className="flex min-h-screen">
        {loading && (
          <div className="loader">
            <i className="fs-1 fas fa-home house-icon"></i>
            <div className="text">Loading...</div>
          </div>
        )}
        <div className="w-1/5 bg-white flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 border-none bg-neutral-400"></div>
        <div className="w-full ms-5">
          <div className="mt-5">
            <p className="text-md font-medium mb-3">
              Click To View Party Details :
              <Button
                onClick={(e) => {
                  generatePdf(e);
                  window.open(
                    `https://localhost:44378//Report/MyReport.aspx?PDE_ID=${pde}`,
                    "_blank"
                  );
                }}
                className="px-4 py-2 ms-2 bg-blue-500 text-white rounded-full text-sm"
              >
                View Pdf
              </Button>
            </p>
          </div>
          <div className="mt-5">
            <p className="text-md font-medium mb-3">
              Send Email Link To Parties :
              <Button
                className={`px-4 py-2 ms-2 rounded-full text-sm ${
                  GeneratePdf
                    ? "bg-blue-500 text-white cursor-pointer"
                    : "bg-gray-400 text-gray-200 cursor-not-allowed"
                }`}
                onClick={handleSendClick}
                disabled={!GeneratePdf}
              >
                Send
              </Button>
            </p>
          </div>

          <div className="mt-5">
            <p className="text-md font-medium mb-3">
              Click To View Party Details :
              <Button
                onClick={fetchPdf}
                className="px-4 py-2 ms-2 bg-blue-500 text-white rounded-full text-sm"
              >
                View Signed Document
              </Button>
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-md font-bold">First Party</p>
            <div className="grid grid-cols-3 gap-4 mt-2">
              {partyDetailsData?.firstparty?.map((item, index) => (
                <div
                  key={index}
                  className="relative flex items-start p-2 mb-2 rounded shadow"
                >
                  {/* Status Badge */}
                  <span
                    className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                      item.status === "Pending"
                        ? "bg-yellow-300"
                        : item.status === "Signed"
                        ? "bg-green-300"
                        : item.status === "Declined"
                        ? "bg-red-500"
                        : ""
                    }`}
                  >
                    {item.status}
                  </span>
                  <p className="text-sm font-bold">{item.sNo}.</p>
                  <img
                    className="w-32 h-32 object-cover ms-2 mr-6"
                    src={Photo_dummy}
                    alt="Profile"
                  />
                  {/* Content Section */}
                  <div className="mr-10 text-sm">
                    {/* <h2 className="text-sm font-bold">Name : {item.nameEng}</h2> */}
                    <p className="text-gray-600">
                      <b>Name : </b>
                      {item.nameEng}
                    </p>
                    <p className="text-gray-600">
                      <b>Address : </b>
                      {item.address}
                    </p>
                    <p className="text-gray-600">
                      <b>D.O.B :</b> {item.dob}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <p className="text-md font-bold">Second Party</p>
            <div className="grid grid-cols-2 gap-4 mt-3">
              {partyDetailsData?.secondparty?.map((item, index) => (
                <div
                  key={index}
                  className="relative flex items-start p-2 mb-2 rounded shadow"
                >
                  <span
                    className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                      item.status === "Pending"
                        ? "bg-yellow-300"
                        : item.status === "Signed"
                        ? "bg-green-300"
                        : item.status === "Declined"
                        ? "bg-red-500"
                        : ""
                    }`}
                  >
                    {item.status}
                  </span>
                  <p className="text-sm font-bold">{item.sNo}.</p>
                  <img
                    className="w-32 h-32 object-cover ms-2 mr-6"
                    src={Photo_dummy}
                    alt="Profile"
                  />
                  <div className="text-sm mr-10">
                    {/* <h2 className="text-sm font-bold">Name : {item.nameEng}</h2> */}
                    <p className="text-gray-600 ">
                      <b>Name : </b>
                      {item.nameEng}
                    </p>
                    <p className="text-gray-600">
                      <b>Address : </b>
                      {item.address}
                    </p>
                    <p className="text-gray-600">
                      <b>D.O.B :</b> {item.dob}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <p className="text-md font-bold">Witness</p>
            <div className="grid grid-cols-2 gap-4 mt-3">
              {partyDetailsData?.witness?.map((item, index) => (
                <div
                  key={index}
                  className="relative flex items-start p-2 mb-2 rounded shadow"
                >
                  <span
                    className={`absolute top-1 right-1 text-white font-bold px-2 py-1 rounded text-xs ${
                      item.status === "Pending"
                        ? "bg-yellow-300"
                        : item.status === "Signed"
                        ? "bg-green-300"
                        : item.status === "Declined"
                        ? "bg-red-500"
                        : ""
                    }`}
                  >
                    {item.status}
                  </span>
                  <p className="text-sm font-bold">{item.sNo}.</p>
                  <img
                    className="w-32 h-32 object-cover ms-2 mr-6"
                    src={Photo_dummy}
                    alt="Profile"
                  />
                  <div className="text-sm mr-10">
                    {/* <h2 className="text-sm font-bold">Name : {item.nameEng}</h2> */}
                    <p className="text-gray-600">
                      <b>Name : </b>
                      {item.nameEng}
                    </p>
                    <p className="text-gray-600">
                      <b>Address : </b>
                      {item.address}
                    </p>
                    <p className="text-gray-600">
                      <b>D.O.B :</b> {item.dob}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ESign;

//K H A L I D  END
